<div class="pagination" *ngIf="dataSize !== 0">
  <ul class="list">
    <li
      class="item"
      (click)="changePage(currentPage - 1)"
      *ngIf="currentPage !== 1"
    >
      <span class="chevron left"></span>
    </li>
    <ng-container *ngIf="currentList[0] > pageList[0]">
      <li class="item" (click)="changePage(pageList[0])">
        {{ pageList[0] }}
      </li>
      ...
    </ng-container>
    <li
      *ngFor="let item of currentList"
      class="item"
      [class.ative]="currentPage === item"
      (click)="changePage(item)"
    >
      {{ item }}
    </li>
    <ng-container
      *ngIf="
        currentList[currentList.length - 1] < pageList[pageList.length - 1]
      "
    >
      ...
      <li class="item" (click)="changePage(pageList[pageList.length - 1])">
        {{ pageList[pageList.length - 1] }}
      </li>
    </ng-container>
    <li
      class="item"
      (click)="changePage(currentPage + 1)"
      *ngIf="currentPage !== totalPage"
    >
      <span class="chevron right"></span>
    </li>
  </ul>
</div>
